import React, { useRef } from 'react';
import { XYCoord } from 'dnd-core';
import { DragSourceMonitor, DropTargetMonitor, useDrag, useDrop } from 'react-dnd';
import { ItemStyle, DataProps, RenderItem } from './interface';
interface IProps extends ItemStyle, DataProps, RenderItem {
    index: number;
    moveCard: (dragIndex: number, hoverIndex: number, category?: { index: number, children: Array<any> } ) => void;
    category?: { index: number, children: Array<any> } ;
}

export default function MenuItem({ type, index, dataList, category, moveCard, moveEnd, itemClassName, itemStyle, itemHoverStyle, renderItem }: IProps) {

    const data = category? category.children[index]: dataList[index];

    const ref = useRef<HTMLDivElement>(null);

    const [collected, drag, dragPreview] = useDrag({
            type,
            // item 中包含 index 属性，则在 drop 组件 hover 和 drop 是可以根据第一个参数获取到 index 值
            item: {  type, index , category },
            collect: (monitor: DragSourceMonitor) => {
                return {
                    isDragging: monitor.isDragging(),
                };
            },
            end(_: unknown, monitor: DragSourceMonitor) {
                moveEnd(dataList, category ? 'menu' : '');
            },
    });
    const isDragging = collected.isDragging;
   
    const [, drop] = useDrop({
        accept: type,
        canDrop(item:object, monitor: DropTargetMonitor) {
            return true;
        },
        hover(item: { type: string; index: number; category: any}, monitor: DropTargetMonitor) {
            if (!ref.current) {
                return;
            }
            const dragIndex = item.index;
            const hoverIndex = index;

            // 拖拽元素下标与鼠标悬浮元素下标一致时，不进行操作
            if (dragIndex === hoverIndex) {
                return;
            }
            if(category && item.category){
                if(category.index !== item.category.index) { //同一个分类下面appCategoryName
                    return;
                }
            }

            // 确定屏幕上矩形范围
            const hoverBoundingRect = ref.current!.getBoundingClientRect();

            // 获取中点垂直坐标
            const hoverMiddleY =
                (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

            // 确定鼠标位置
            const clientOffset = monitor.getClientOffset();

            // 获取距顶部距离
            const hoverClientY = (clientOffset as XYCoord).y - hoverBoundingRect.top;

            /**
             * 只在鼠标越过一半物品高度时执行移动。
             *
             * 当向下拖动时，仅当光标低于50%时才移动。
             * 当向上拖动时，仅当光标在50%以上时才移动。
             *
             * 可以防止鼠标位于元素一半高度时元素抖动的状况
             */

            // 向下拖动
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                return;
            }

            // 向上拖动
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                return;
            }

            // 执行 move 回调函数
            moveCard(dragIndex, hoverIndex, category);
            // 将 hoverIndex 赋值给 item 的 index 属性
            if (item.index !== undefined) {
                item.index = hoverIndex;
            }
        },
    });
    let hoverStyle: React.CSSProperties = {
        // 默认 拖拽状态时透明度 0.2，正常情况透明度为 1
       // opacity: isDragging ? 0.2 : 1,
    };
    if (itemHoverStyle && isDragging) {
        hoverStyle = { ...itemHoverStyle };
    }
    // 使用 drag 和 drop 对 ref 进行包裹，则组件既可以进行拖拽也可以接收拖拽组件
    //drag(drop(ref));
    dragPreview(drop(ref));
    return (
        <div ref={ref} style={{ ...itemStyle, ...hoverStyle }} className={itemClassName}>
            {
                renderItem(data, index, category, drag)
            }
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/display/components/Drop/MenuItem.tsx